	export enum PatientInsuranceCodeTypeEnum {
		HearingAids = 1,
		Test = 2,
		Diagnostics = 3
	}
